import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Redirect } from "react-router-dom";
import { Box, HStack, Pressable, Text } from "native-base";
import Svg from "react-native-svg";
import { CommonTabs } from "../../../components/tabs";
import { COLORS } from "../../../utils/colors";
import Logo from "../../../utils/logo";
import { activeEventTab, activePackagesTab } from "../../../store/reducers/eventSlice";
import {
  NotificationList,
  SendNotification,
} from "./modalChildren/notification";
import { Logout } from "./logout";
import { getNotificationAPI } from "../../../api/apis/notification";
import { hasPermission } from "../../../utils/permission";
import { redirectToCMS } from "../../../utils/cmsRedirect";
import { logoutSVG } from "../../../utils/svg";
import { getUserInformations } from "../../../api/apis/login";

const WebHeader = ({
  showTabs = true,
  mt = 2,
  updateDataTabChange = () => {},
  quicklink = "",
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const notify = useSelector((state) => {
    return state.event.notification;
  });
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [activeEvent, setActiveEvent] = useState(activeTab);
  const tabs = [
    { key: "mice", title: "MICE", show: true },
    { key: "event", title: "Event", show: true },
    { key: "packages", title: "Packages", show: hasPermission("PACKAGES_TAB") },
    { key: "meet", title: "Quick Meet", show: hasPermission("QUICK_MEET") }
  ];
  const [notificationData, setNotificationData] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [info, setInfo] = useState(null);
  useEffect(() => {
    getNotification();
    getUserInformations().then((res) => {
      setInfo(res.data.data.data);
    });
    // const intervalId = setInterval(() => {
    //   getNotification();
    // }, 10000);

    // return () => clearInterval(intervalId);
  }, [notify]);

  const getFormattedDate = (dates) => {
    const reformattedDateString = dates.replace(
      /(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})/,
      "$3-$2-$1T$4"
    );
    const originalDate = new Date(reformattedDateString);
    originalDate.setHours(originalDate.getHours() + 5);
    originalDate.setMinutes(originalDate.getMinutes() + 30);
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      // timeZone: "UTC"
    }).format(originalDate);

    return formattedDate;
  };

  async function getNotification() {
    let notifiy = await getNotificationAPI();
    if (notifiy?.data?.data?.data) {
      let notify = [],
        count = 0;
      Object.keys(notifiy.data.data.data).length > 0 &&
        notifiy.data.data.data["notifications data"].map((item) => {
          notify.push({
            id: item._id,
            event_id: item.event_id,
            image: item.image,
            video: item.video,
            description: item.description,
            datetime: getFormattedDate(item.datetime),
            status: item.read,
            package_id: item.package_id,
            type: item.notification_type,
            mis: item?.mis
          });
          count = !item.read ? count + 1 : count;
        });
      if (notifiy.data.data.data.unread_count) {
        setUnreadCount(notifiy.data.data.data.unread_count);
      }
      if (notifiy.data.data.data.unread_count === 0) {
        setUnreadCount(0);
      }
      setNotificationData(notify);
      return notifiy.data.data.data.unread_count;
    }
    return 0;
  }

  if (shouldRedirect) {
    quicklink === "yes" && dispatch(activeEventTab(activeEvent));
    return <Redirect to="/home" />;
  }

  const setActiveButton = (key) => {
    updateDataTabChange();
    dispatch(activeEventTab(key));
    dispatch(activePackagesTab("New request"));
    setActiveEvent(key);
    if (
      location.pathname === "/event-detail" ||
      (key === "packages" && quicklink === "yes") ||
      (key === "meet" && quicklink === "yes")
    ) {
      setShouldRedirect(true);
    }
  };

  return (
    <>
      <Box
        mx={8}
        mt={mt}
        pl={50}
        pr={"30px"}
        flexDirection="row"
        justifyContent="space-between"
        bg={COLORS.WHITE_COLOR}
        pb={!showTabs && 1}
      >
        <Logo w={158} h={45} />
        <Box mt={2}>
          {(showTabs === "true" || showTabs === true) && (
            <CommonTabs
              tabs={tabs}
              activeButton={activeTab}
              setActiveButton={setActiveButton}
            />
          )}
        </Box>
        <Box>
          <HStack alignItems={"center"}>
            {(hasPermission("ADMIN") || info?.role === 'initiator') && (
              <Pressable onPress={() => redirectToCMS()} mr={3}>
                <HStack alignItems="center" space={2} bg={COLORS.WHITE_COLOR} px={3} py={2}>
                  <Svg width="24" height="24" viewBox="0 0 24 28">
                    {logoutSVG}
                  </Svg>
                  <Text color="#FF0000" fontSize="sm" fontWeight="medium">
                    App CMS
                  </Text>
                </HStack>
              </Pressable>
            )}
            {hasPermission("SEND_NOTIFICATION") && <SendNotification />}
            <NotificationList
              notificationData={notificationData}
              unreadCount={unreadCount}
              getNotification={getNotification}
            />
            <Box mt={2}>
              <Logout />
            </Box>
          </HStack>
        </Box>
      </Box>
    </>
  );
};

export default WebHeader;
